import { fromJS } from 'immutable';
import *  as actions from '../utils/Constants';

export default (state = getInitialState(), action) => {
    switch (action.type) {
        case 'GET_ROLES_FULFILLED':
            {
                return state.withMutations(mut => {
                    mut.set('roles', fromJS(action.payload));
                    return mut;
                });
            }


        case 'GET_USERS_FULFILLED':
        case actions.DELETE_USERS + actions.FULFILLED:
            {
                return state.withMutations(mut => {
                    mut.set('userList', fromJS(action.payload));
                    return mut;
                });
            }
    

        case actions.TOGGLE_NEW_USER_MODAL: {
            return state.withMutations(mut => {
                mut.set('passwordValidationMessages', fromJS([]));
                mut.set('showNewUserModal', !state.get('showNewUserModal'));
                return mut;
            });
        }

        case actions.SAVE_NEW_USER + actions.FULFILLED:
            return state.withMutations(mut => {

                if (action.payload.validationMessages && action.payload.validationMessages.length > 0) {
                    const validationMessages = fromJS(action.payload.validationMessages);
                    mut.set('passwordValidationMessages', validationMessages);
                    mut.set('showNewUserModal', validationMessages.size > 0);    
                }
                else {
                    mut.set('newUserId', action.payload.data.userId);
                    mut.set('showNewUserModal', false);
                }

                return mut
            });
        case actions.CLEAR_USERS:
            return getInitialState();
        default:
            return state;
    }
}

const getInitialState = () => {
    return fromJS({
        roles: [],
        userList: [],
        showNewUserModal: false,
        passwordValidationMessages: []
    });
};